import coverImg from "assets/images/v150/bg.webp"
import titleImg from "assets/images/v150/title.webp"

export const v150Config = {
  cover: { en: coverImg },
  title: { en: titleImg },
}
